import { api } from '../api.js';
import { store } from '../store.js';
import { navigate } from '../router.js';

export async function renderOnboardingPage({ root }) {
  root.innerHTML = `
    <div class="onboarding">
      <h1>Добро пожаловать в Chunkly.ru!</h1>
      <p class="lead">Выберите свой уровень английского для старта</p>
      <div class="level-cards">
        <div class="level-card" data-level="B1">
          <h2>B1</h2>
          <div class="sub">Средний (IELTS 5)</div>
          <div class="desc">Коллокации для повседневной речи и простых текстов.</div>
          <div class="count">50 коллокаций</div>
          <button>Выбрать B1</button>
        </div>
        <div class="level-card" data-level="B2">
          <h2>B2</h2>
          <div class="sub">Выше среднего (IELTS 6–7)</div>
          <div class="desc">Академические chunks для Writing и Speaking.</div>
          <div class="count">80 коллокаций</div>
          <button>Выбрать B2</button>
        </div>
      </div>
      <p class="hint">Уровень можно изменить позже в настройках</p>
    </div>
  `;

  root.querySelectorAll('.level-card').forEach((card) => {
    card.addEventListener('click', async () => {
      const level = card.dataset.level;
      try {
        const { user } = await api.auth.setLevel(level);
        store.user = user;
        navigate('/trainer');
      } catch {
        alert('Не удалось сохранить уровень. Попробуйте снова.');
      }
    });
  });
}
